import React from "react";

export default function PageButtons({ page, totalPages, onPage }) {
    if (totalPages <= 1) return null;

    const makeRange = (a, b) => {
        const arr = [];
        for (let i = a; i <= b; i++) arr.push(i);
        return arr;
    };

    // δείξε: 1 ... (page-1,page,page+1) ... last
    const pages = [];
    const left = Math.max(2, page - 1);
    const right = Math.min(totalPages - 1, page + 1);

    pages.push(1);

    if (left > 2) pages.push("...");
    pages.push(...makeRange(left, right));
    if (right < totalPages - 1) pages.push("...");

    if (totalPages > 1) pages.push(totalPages);

    // remove duplicates (π.χ. όταν totalPages μικρό)
    const normalized = pages.filter((v, i) => i === 0 || v !== pages[i - 1]);

    return (
        <div className="flex space-x-2">
            {normalized.map((p, idx) => {
                if (p === "...") {
                    return (
                        <span key={`dots-${idx}`} className="px-2 py-2 text-sm text-gray-500">
              ...
            </span>
                    );
                }

                const active = p === page;
                return (
                    <button
                        key={p}
                        onClick={() => onPage(p)}
                        className={
                            active
                                ? "px-3 py-2 bg-custom-green text-white rounded-lg text-sm"
                                : "px-3 py-2 border rounded-lg text-sm hover:bg-gray-100"
                        }
                    >
                        {p}
                    </button>
                );
            })}
        </div>
    );
}
